import axios from "../customize_axios"

export const getAllBooks = async (token, page) => {
    try {
        const response = await axios.get(
            `api/books/admin/details?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAllBooks", error.response ? error.response.data : error.message)
        return []
    }
}

export const getBookByCategoryID = async (token, categoryID, page) => {
    try {
        const response = await axios.get(
            `/api/books/admin/details-by-category/${categoryID}?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getBookByCategoryID", error.response ? error.response.data : error.message)    
    }
}

export const getBooksBySearch = async (token, searchText, page) => {
    try {
        const response = await axios.get(
            `api/books/admin/search?keyword=${searchText}&page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getBooksBySearch", error.response ? error.response.data : error.message)   
    }
}

export const addBook = async (token, formData) => {
    try {
        const response = await axios.post(
            "api/books/add", 
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response
    } 
    catch (error) {
        console.log("Add Book: ",  error.response ? error.response.data : error.message)
    }
}

export const updateBook = async(token, formData) => {
    try {
        const response =  await axios.post(
            "api/books/update",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            }
    
        )
        return response
    } 
    catch (error) {
        console.log("Update Book: ", error.response ? error.response.data : error.message)
    }
}

export const deleteBook = async (token, bookID) => {
    try {
        const response = await axios.post(
            `api/books/hide/${bookID}`,
            {},
            {
                headers: {
                    Authorization:  `Bearer ${token}`,
                    "Content-Type": "application/json"
                } 
            }
        )
        return response
    } 
    catch (error) {
        console.log("Delete Book:", error.response ? error.response.data : error.message)    
    }
}

export const getAllHiddenBooks = async (token, page) => {
    try {
        const response = await axios.get(
            `api/books/is-hidden?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAllHiddenBooks: ", error.response ? error.response.data : error.message)    
    }
}

export const getHiddenBooksByCategory = async (token, categoryID, page) => {
    try {
        const response = await axios.get(
            `api/books/category/${categoryID}/is-hidden?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getHiddenBooksByCategory: ", error.response ? error.response.data : error.message)    
    }
}

export const unhideBook = async (token, bookID) => {
    try {
        const response = await axios.get(
            `api/books/unhide/${bookID}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("unhide book: ", error.response ? error.response.data : error.message)    
    }
}